"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {TitleSectionEspaceProLarge} from "@/components/common/title-section-espace-pro";
import {PaveScaleCard} from "@/components/common/pave-scale-card";
import {Button} from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Plans d’Actions & Rapports d’Activités"}
                                middleBreadcrumbs={[
                                    {title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"},
                                ]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <TitleSectionEspaceProLarge title={"Les rapports d'activités 2022"} />
                <div className={"grid grid-cols-1 md:grid-cols-3"}>
                    <PaveScaleCard title={<>Rapport <br /> d'activités 2022</>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Rapport-dActivites-2022.pdf"
                                   image={"/images/espace-pro/office-du-tourisme/plan-actions-rapports-activites/rapport-activites-2022.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>
                </div>
            </SectionPage>

            <SectionPage sectionType="lg" className={"mt-6"}>
                <TitleSectionEspaceProLarge title={"Les plans d'actions"} />

                <div className={"flex flex-col md:flex-row gap-4"}>
                    <Button variant={"bleuMarine"}>Télécharger le plan d'Action 2022-2027</Button>
                    <Button variant={"bleuMarine"} onClick={() => navigate("/pdf-viewer/Plan-Srategique-2022-2027.pdf")}>Télécharger le plan Stratégiqueu 2022-2027</Button>
                </div>
            </SectionPage>

            <SectionPage sectionType="lg" className={"mt-6"}>
                <TitleSectionEspaceProLarge title={"Bilan qualité"} />
                <p className={"text-normal mb-4"}>Côte d’Ivoire Tourisme s’engage dans une démarche Qualité et de satisfaction des clients.</p>

                <Button variant={"bleuMarine"}>Bilan Qualité 2022</Button>
            </SectionPage>

        </div>
    );
}
